import { useState } from "react";
import { AudioOutlined, PlusOutlined } from "@ant-design/icons";
import { Input, Space, Button, Card, Table, Switch } from "antd";
import IkevDrawer from "../IkevDrawer";
import styled from "styled-components";
const { Search } = Input;

const onSearch = (value) => console.log(value);
const Wireguard = () => {
  const [size, setSize] = useState("default");

  const onChange = (checked) => {
    console.log(`switch to ${checked}`);
  };

  const columns = [
    {
      title: "name",
      width: 80,
      dataIndex: "name",
      key: "name",
      fixed: "left",
    },
    {
      title: "register",
      width: 60,
      dataIndex: "register",
      key: "register",
      sorter: true,
    },
    {
      title: "server code",
      width: 55,
      dataIndex: "server_code",
      key: "1",
    },
    {
      title: "expire",
      width: 70,
      dataIndex: "expire",
      key: "2",
    },
    {
      title: "status",
      width: 45,
      dataIndex: "status",
      key: "3",
    },
    {
      title: "traffic(GB)",
      width: 50,
      dataIndex: "traffic",
      key: "4",
    },
    {
      title: "switch",
      width: 50,
      dataIndex: "switch",
      key: "5",
    },
    {
      title: "user",
      width: 105,
      dataIndex: "user",
      key: "6",
    },
    {
      title: "connection",
      width: 75,
      dataIndex: "connection",
      key: "7",
    },
    {
      title: "qrcode",
      width: 85,
      dataIndex: "qrcode",
      key: "8",
    },
    {
      title: "action",
      width: 60,
      dataIndex: "action",
      key: "9",
    },
  ];

  const Gbp = styled.p`
    border-radius: 5px;
    background-color: #00b600;
    color: white;
    text-align: center;
  `;
  const data = [
    {
      key: "1",
      name: "John Brown",
      register: "22/10/16 - 12:17:35",
      server_code: 183038,
      expire: <Button type="primary">Extend</Button>,
      status: <Switch defaultChecked onChange={onChange} />,
      traffic: <Gbp>0.098</Gbp>,
      switch: "",
      user: (
        <Button type="primary" danger icon={<PlusOutlined />} size={size}>
          Assign To User
        </Button>
      ),
      connection: <Button>Download</Button>,
      qrcode: <Button>View QRcode</Button>,
      edit: <Button type="primary">Edit</Button>,
      action: (
        <Button type="primary" danger>
          Delete
        </Button>
      ),
    },
    {
      key: "1",
      name: "John Brown",
      register: "22/10/16 - 12:17:35",
      server_code: 183038,
      expire: <Button type="primary">Extend</Button>,
      status: <Switch defaultChecked onChange={onChange} />,
      traffic: <Gbp>0.098</Gbp>,
      switch: "",
      user: (
        <Button type="primary" danger icon={<PlusOutlined />} size={size}>
          Assign To User
        </Button>
      ),
      connection: <Button>Download</Button>,
      qrcode: <Button>View QRcode</Button>,
      edit: <Button type="primary">Edit</Button>,
      action: (
        <Button type="primary" danger>
          Delete
        </Button>
      ),
    },
    {
      key: "1",
      name: "John Brown",
      register: "22/10/16 - 12:17:35",
      server_code: 183038,
      expire: <Button type="primary">Extend</Button>,
      status: <Switch defaultChecked onChange={onChange} />,
      traffic: <Gbp>0.098</Gbp>,
      switch: "",
      user: (
        <Button type="primary" danger icon={<PlusOutlined />} size={size}>
          Assign To User
        </Button>
      ),
      connection: <Button>Download</Button>,
      qrcode: <Button>View QRcode</Button>,
      edit: <Button type="primary">Edit</Button>,
      action: (
        <Button type="primary" danger>
          Delete
        </Button>
      ),
    },
    {
      key: "1",
      name: "John Brown",
      register: "22/10/16 - 12:17:35",
      server_code: 183038,
      expire: <Button type="primary">Extend</Button>,
      status: <Switch defaultChecked onChange={onChange} />,
      traffic: <Gbp>0.098</Gbp>,
      switch: "",
      user: (
        <Button type="primary" danger icon={<PlusOutlined />} size={size}>
          Assign To User
        </Button>
      ),
      connection: <Button>Download</Button>,
      qrcode: <Button>View QRcode</Button>,
      edit: <Button type="primary">Edit</Button>,
      action: (
        <Button type="primary" danger>
          Delete
        </Button>
      ),
    },
    {
      key: "1",
      name: "John Brown",
      register: "22/10/16 - 12:17:35",
      server_code: 183038,
      expire: <Button type="primary">Extend</Button>,
      status: <Switch defaultChecked onChange={onChange} />,
      traffic: <Gbp>0.098</Gbp>,
      switch: "",
      user: (
        <Button type="primary" danger icon={<PlusOutlined />} size={size}>
          Assign To User
        </Button>
      ),
      connection: <Button>Download</Button>,
      qrcode: <Button>View QRcode</Button>,
      edit: <Button type="primary">Edit</Button>,
      action: (
        <Button type="primary" danger>
          Delete
        </Button>
      ),
    },
  ];

  const suffix = (
    <AudioOutlined
      style={{
        fontSize: 16,
        color: "#1890ff",
      }}
    />
  );

  const TopD = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
    margin-top: -17px;
  `;
  return (
    <div className="site-card-border-less-wrapper">
      <TopD>
        <p>Wireguard : 5</p>
        <Space direction="vertical">
          <Search
            placeholder="name or link..."
            onSearch={onSearch}
            style={{
              width: 200,
            }}
          />
        </Space>
        <IkevDrawer />
      </TopD>
      <Card style={{ border: "none" }}>
        <Table
          columns={columns}
          dataSource={data}
          scroll={{
            y: 285,
            x: 1300,
          }}
          bordered
        />
      </Card>
    </div>
  );
};

export default Wireguard;
